var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { ActionType } from './actionTypes';
export var initialState = {
    colors: [],
    index: -1,
    value: '',
    error: false,
};
export var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, _a = action.payload, payload = _a === void 0 ? '' : _a;
    var value = payload.startsWith('#') ? payload : "#" + payload;
    var nextIndex = state.index + 1;
    var prevIndex = state.index - 1;
    switch (type) {
        case ActionType.undo_color:
            return __assign(__assign({}, state), { index: prevIndex, value: state.colors[prevIndex] });
        case ActionType.redo_color:
            return __assign(__assign({}, state), { index: nextIndex, value: state.colors[nextIndex] });
        case ActionType.update_value: {
            if (value.length >= 8 || value === state.colors[state.index]) {
                return state;
            }
            //verify we have received valid hex for typed in colors
            var regex = /^#(?:[0-9a-fA-F]{3}){1,2}$/g;
            if (!regex.test(value)) {
                return __assign(__assign({}, state), { value: value, error: true });
            }
            return {
                colors: __spreadArray(__spreadArray([], state.colors.slice(0, nextIndex)), [value]),
                index: nextIndex,
                value: value,
                error: false,
            };
        }
        case ActionType.add_color:
            if (value === state.colors[state.index]) {
                return state;
            }
            return {
                colors: __spreadArray(__spreadArray([], state.colors.slice(0, nextIndex)), [value]),
                index: nextIndex,
                value: value,
                error: false,
            };
        case ActionType.reset:
            return {
                colors: [state.colors[0]],
                index: 0,
                value: state.colors[0],
                error: false,
            };
        default:
            return state;
    }
};
